import { observer } from 'mobx-react';
import { ForeclosureAttorneyForm } from './ForeclosureAttorneyForm';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';

export type ForeclosureAttorneyItemProps = {
  open: boolean;
  onClose: () => void;
  loanId?: string;
  showAlert?: (message: string, type: 'success' | 'danger') => void;
  setIsLoading?: (key: string, value: boolean) => void;
  reloadLoan?: (rerenderGrid?: () => void) => void;
  document?: DocumentType;
};

export const ForeclosureAttorneyItem = observer(
  ({
    open,
    onClose,
    loanId,
    showAlert,
    setIsLoading,
    reloadLoan,
    document,
  }: ForeclosureAttorneyItemProps) => {
    const dialogContent = (
      <ForeclosureAttorneyForm
        open={open}
        handleClose={onClose}
        loanId={loanId}
        showAlert={showAlert}
        setIsLoading={setIsLoading}
        reloadLoan={reloadLoan}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Foreclosure Attorney"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Foreclosure Attorney"
            maxWidth="md"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default ForeclosureAttorneyItem;
